import {useEffect} from 'react'
import {CardEnum} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {usePlayerValidators} from '../../store/selectors/usePlayerValidators.ts'

/**
 * Hook that ensures offered cards in trade creator is always a subset of player's inventory.
 * This handles cases where a player's cards are taken away (e.g., by monopoly card)
 * while they have cards selected for a trade offer.
 */
export const useOfferedCardsSubsetOfInventory = () => {
    const myColor = useGameStore((state) => state.myColor)
    const offeredCards = useGameStore((state) => state.gameCardInventory.selectedCards)
    const setOfferedCards = useGameStore((state) => state.gameCardInventory.setSelectedCards)
    const {getPlayerValidator} = usePlayerValidators()

    const myPlayerValidator = getPlayerValidator(myColor)
    const myResourceCards = myPlayerValidator.resourceCards.cards

    useEffect(() => {
        if(offeredCards.length === 0) return

        const availableCards = [...myResourceCards]
        const validOfferedCards: CardEnum[] = []

        for(const card of offeredCards) {
            const isResourceWildcard = card === CardEnum.AnyResource
            if(isResourceWildcard) {
                validOfferedCards.push(card)
                continue
            }

            const isCardAvailable = ArrayUtils.removeElementFromArray(availableCards, card)
            if(isCardAvailable) validOfferedCards.push(card)
        }

        const hasRemovedCards = validOfferedCards.length !== offeredCards.length
        if(hasRemovedCards) setOfferedCards(validOfferedCards)
    }, [myResourceCards, offeredCards, setOfferedCards])
}
